import { inject, Injectable } from '@angular/core';
import { KeycloakService } from '@vectronic/keycloak-angular';
import { adminUserDtos } from '@vectronic/openApi-admin';

@Injectable({ providedIn: 'root' })
export class LocalStorageService {
  version: string;
  keycloakService = inject(KeycloakService);

  constructor() {
    this.version = '1.1';
    this.checkLocalStorageVersion();
  }

  private checkLocalStorageVersion() {
    const localStorageVersion = localStorage.getItem('localStorageVersion');
    if (localStorageVersion == null || localStorageVersion !== this.version) {
      localStorage.clear();
      localStorage.setItem('localStorageVersion', this.version);
    }
  }

  setDatatableColumns(uniqueTableId: string, dto: adminUserDtos.DatatableSettings) {
    this.set(`columns-${uniqueTableId}`, dto);
  }

  getDatatableColumns(uniqueTableId: string) {
    const jsonString = this.get(`columns-${uniqueTableId}`);
    if (jsonString) return JSON.parse(jsonString) as adminUserDtos.DatatableSettings;
  }

  set(key: string, value: unknown, JSONstringify = true) {
    value = JSONstringify ? JSON.stringify(value) : value;
    localStorage.setItem(this.getUsername() + '_' + key, value as string);
  }

  get(key: string) {
    return localStorage.getItem(this.getUsername() + '_' + key);
  }

  remove(key: string) {
    localStorage.removeItem(this.getUsername() + '_' + key);
  }

  private getUsername() {
    let username = 'unknown';
    try {
      username = this.keycloakService.getUsername();
    } catch (e) {
      console.error(e);
    }
    return username;
  }
}
